export default {
    lists: [
        // '/distribution/personal/index',
        // '/distribution/stockorder/list',
        // '/distribution/personal/info/index',
        // '/distribution/personal/message/list',
        // '/distribution/wallet/index',
        // '/distribution/wallet/yearrecord',
        // '/distribution/wallet/bankcard',
        // '/distribution/wallet/record',
        // '/distribution/wallet/recharge',
        // '/distribution/wallet/withdraw',
        // '/address/list',
        // '/address/edit',
        // '/address/addex',
        // '/distribution/activity/center',
        // '/distribution/stockorder/list',
        // '/distribution/shoporder/details',
        // '/distribution/stockorder/list',
        // '/distribution/activity/index',
        // '/distribution/index',
        // '/distribution/personal/message/list',
        // '/retail/info/list',
        // '/distribution/retail',
        // '/distribution/goodscomb',
        // '/distribution/goodsdetail',
        // '/distribution/shoporder/confirm',
        // '/distribution/personal/info/index',
        // '/distribution/personal/info/nickname',
        // '/distribution/personal/info/wechat',
        // '/distribution/improveidentity',
        // '/loginpassword',
        // '/distribution/personal/info/paypassword',
        // '/address',
        // '/intro',
        // '/retail/personal/info/about',
        // '/logistics',
        // '/distribution/stock/list',
        // '/distribution/shoporder/add',
        // '/distribution/personal/message/details',
        // '/distribution/conversion/index',
        // '/distribution/inventory/list',
        // '/distribution/inventory/details',
        // '/distribution/dispatch/index',
        // '/distribution/dispatch/confirm'
        // 不能进入的页面地址
        '/distribution/help/index',
        '/distribution/help/lis',
        '/distribution/help/details',
        '/distribution/invite/index',
        '/distribution/saleorder/list',
        '/distribution/saleorder/details',
        '/distribution/partner/index',
        '/distribution/partner/partner_message',
        '/distribution/partner/list',
        '/distribution/partner/inventory',
        '/distribution/partner/list2',
        '/distribution/settle/index',
        '/distribution/settle/month',
        '/distribution/settle/year',
        '/distribution/settle/account',
        '/distribution/settle/rule',
        '/distribution/settle/integralhistory',
        '/distribution/improveidentity'
    ],
    isUrl: function(url, type) {
        let that = this;
        let url_arr = url.split('?');
        let flag = false;
        if (that.lists.indexOf(url_arr[0]) != -1) {
            flag = true;
        }
        console.log(flag, 'flag');
        return flag;
    }
}


// WEBPACK FOOTER //
// ./src/common/dealerCantPath.js